import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-512c02dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Kundenspezifische Preise", -1))
const _hoisted_3 = { class: "editor-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Bitte wählen Sie einen Kunden aus:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "default",
  selected: "",
  disabled: ""
}, "Auswählen ...", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Gewähltes Abonnement:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Preis pro Jahr (in EUR):", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Startdatum Preisanpassung:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Dauer Preisanpassung (in Monaten):", -1))
const _hoisted_11 = { class: "button-container" }

import { Subscription, User } from "@/store/model";
import { subscriptionStorageModule } from "@/store/subscription-storage";
import { userStorageModule } from "@/store/user-storage";
import { Ref, ref, watch } from "vue";
import BaseInput from "../base/base-input.vue";
import BaseButton from "../base/base-button.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEditing = ref(false);
const shakeButton = ref(false);

const selectedUserId = ref("default");
const selectedUser: Ref<User|undefined> = ref(undefined);

const userSubscription: Ref<Subscription | undefined> = ref(undefined);
const userPrice = ref(0);
const priceIsValid = ref(true);
const userPriceStartDate = ref("");
const startDateIsValid = ref(true);
const userPriceDuration = ref(0);
const durationIsValid = ref(true);

watch(userSubscription, () => {
  // Price for user is either his personal subscription price or the general price of the subscription
  userPrice.value = selectedUser.value?.subscriptionPrice ?? userSubscription.value?.price ?? 0;
  userPriceStartDate.value = selectedUser.value?.subscriptionPriceStart?.toISOString().split("T")[0] ?? "";
  userPriceDuration.value = selectedUser.value?.subscriptionPriceDuration ?? 0;
});

function validatePrice(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  if (value !== "") {
    priceIsValid.value = true;
  } else {
    priceIsValid.value = false;
  }
}

function validateStartDate(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  console.log("Validate Date:", value);
  startDateIsValid.value = true;
}

function validateDuration(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  if (value !== "") {
    durationIsValid.value = true;
  } else {
    durationIsValid.value = false;
  }
}

function changedSelectedCustomer() {
  isEditing.value = false;
  selectedUser.value = userStorageModule.getUsers.find(
    (user) => user.id === selectedUserId.value
  );
  userSubscription.value = subscriptionStorageModule.getSubscriptions.find(
    (subscription) => subscription.id === selectedUser.value?.subscription
  );
}

function toggleEditing() {
  if (isEditing.value) {
    saveUpdate();
  } else {
    startEditing();
  }
}

function startEditing() {
  isEditing.value = true;
}

function stopEditing() {
  isEditing.value = false;
}

function saveUpdate() {
  if (priceIsValid.value && selectedUser.value) {
    const newUser = JSON.parse(JSON.stringify(selectedUser.value));
    newUser.subscriptionPrice = userPrice.value;
    newUser.subscriptionPriceStart = new Date(userPriceStartDate.value);
    newUser.subscriptionPriceDuration = userPriceDuration.value;
    userStorageModule.update(newUser);

    stopEditing();
  } else {
    // Shake button to indicate invalid value
    shakeButton.value = true;
    setTimeout(() => {
      shakeButton.value = false;
    }, 700);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUserId).value = $event)),
              onChange: changedSelectedCustomer
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStorageModule).getUsers, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: user.id,
                  value: user.id
                }, _toDisplayString(`${user.id} - ${user.firstName} ${user.lastName} (${user.username})`), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, selectedUserId.value]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, [
            _createElementVNode("i", null, _toDisplayString(userSubscription.value
                ? userSubscription.value.duration
                : "Kein dazugehöriges Abonnement"), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, [
            _createVNode(BaseInput, {
              width: "300px",
              type: "number",
              valid: priceIsValid.value,
              onBlur: validatePrice,
              modelValue: userPrice.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userPrice).value = $event)),
              disabled: !isEditing.value
            }, null, 8, ["valid", "modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_9,
          _createElementVNode("td", null, [
            _createVNode(BaseInput, {
              width: "300px",
              type: "date",
              valid: startDateIsValid.value,
              onBlur: validateStartDate,
              modelValue: userPriceStartDate.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userPriceStartDate).value = $event)),
              disabled: !isEditing.value
            }, null, 8, ["valid", "modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, [
            _createVNode(BaseInput, {
              width: "300px",
              type: "number",
              valid: durationIsValid.value,
              onBlur: validateDuration,
              modelValue: userPriceDuration.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userPriceDuration).value = $event)),
              disabled: !isEditing.value
            }, null, 8, ["valid", "modelValue", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (isEditing.value)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              title: "Abbrechen",
              onClick: stopEditing
            }))
          : _createCommentVNode("", true),
        _createVNode(BaseButton, {
          title: isEditing.value ? 'Speichern' : 'Bearbeiten',
          class: _normalizeClass({ buttonSave: isEditing.value, shake: shakeButton.value }),
          onClick: toggleEditing,
          disabledButton: userSubscription.value === undefined
        }, null, 8, ["title", "class", "disabledButton"])
      ])
    ])
  ]))
}
}

})